import React from 'react';
import BoxedLayout from './components/layout/BoxedLayout';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Slider from './components/Slider';
import WelcomeSection from './components/WelcomeSection';
import NewsEvents from './components/NewsEvents';
import Footer from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <BoxedLayout>
        <TopBar />
        <Header />
        <Navigation />
        <main className="flex-grow">
          <Slider />
          <WelcomeSection />
          <NewsEvents />
        </main>
        <Footer />
      </BoxedLayout>
    </LanguageProvider>
  );
}

export default App;